import z from 'zod';
export var FontFamilyEnum = z["enum"](['Montserrat', 'Open Sans', 'Source Code Pro']);
export var TypographyClassEnum = z["enum"](['label', 'body', 'headline', 'display', 'code', 'title']);
// TODO: is there a way to reference `TypographyClassEnum` in this object?
export var FontFamiliesSchema = z.object({
  body: FontFamilyEnum,
  code: FontFamilyEnum,
  display: FontFamilyEnum,
  headline: FontFamilyEnum,
  label: FontFamilyEnum,
  title: FontFamilyEnum
});